<template>
  <article>
    <Feature :title="$t('GROUP_ACCOUNT_MAINTAIN')" :iconClass="'fa-user-circle-o'">
      <FormRow v-show="canAdd || canSearch" :fieldNameArr="[$t('GROUP_ACCOUNT')]">
        <Input ref="in_groupAcc" v-model="groupCode" :maxlength="12" show-word-limit v-upper-case slot="a" />
        <Button type="success" @click="searchGroupAccount" v-show="canSearch" slot="b">{{$t('COMMON_TEXT_SEARCH')}}</Button>
        <Button type="primary" @click="addGroupAccount" v-show="canAdd" slot="c">{{$t('CREATE_ACCOUNT')}}</Button>
        <Button type="primary" @click="uploadGroupAccount" v-show="canAdd" slot="d">{{$t('UPLOAD')}}</Button>
      </FormRow>

      <SupplierPart
        v-if="userType != null && userType == 'External' && checkErpType == 'Y'"
        :group="group"
        :regionList="regionList"
        :checkSpecialFlagRole="checkSpecialFlagRole"
        :specialFlagRoleList="specialFlagRoleList"
        :isUpdate="isUpdate"
        :noGroupAccoutShow="noGroupAccoutShow"
        :system="system"
        @changeEffectiveDate="changeEffectiveDate"
        @createGroupAccount="createGroupAccount"
        @updateGroupAccount="updateGroupAccount"
        ref="External"
      ></SupplierPart>
      <DeltaPart
        v-if="userType != null && (userType != 'External' || checkErpType != 'Y')"
        :group="group"
        :regionList="regionList"
        :checkSpecialFlagRole="checkSpecialFlagRole"
        :specialFlagRoleList="specialFlagRoleList"
        :isUpdate="isUpdate"
        :noGroupAccoutShow="noGroupAccoutShow"
        :roleList="roleList"
        :system="system"
        @changeEffectiveDate="changeEffectiveDate"
        @createGroupAccount="createGroupAccount"
        @updateGroupAccount="updateGroupAccount"
        ref="Delta"
      ></DeltaPart>

      <ContactMaintain
        v-if="isContactShow"
        :group="group"
        :userType="userType"
        :isUpdate="isUpdate"
        :isExceptionApplication="isExceptionApplication"
        @contactConfirm="contactConfirm"
        ref="ContactMaintain"
      ></ContactMaintain>

      <Card v-if="isShowMainData" :title="$t('DATA_MAINTENANCE')" class="card-secondary mt-3">
        <PICodeMaintain
          v-if="userType != null && userType == 'External' && showPiCodeMaintain"
          :piCodeList="piCodeList"
          :group="group"
        ></PICodeMaintain>
        <VNCodeMaintain
          v-if="userType != null && userType == 'External' && showVNCodeMaintain"
          :vnCodeList="vnCodeList"
          :group="group"
        ></VNCodeMaintain>
        <PlantCodeMaintain
          v-if="userType != null && showPlantCodeMaintain"
          :plantList="plantList"
          :group="group"
        ></PlantCodeMaintain>
        <QBRPlantCodeMaintain
          v-if="userType != null && userType == 'Delta' && showQBRPlantCodeMaintain"
          :qbrPlantCodeList="qbrPlantCodeList"
          :group="group"
        ></QBRPlantCodeMaintain>
        <QBRVNCodeMaintain
          v-if="userType != null && userType == 'Delta' && showQBRVNCodeMaintain"
          :qbrVnCodeList="qbrVnCodeList"
          :group="group"
        ></QBRVNCodeMaintain>
        <QBRCategoryMaintain
          v-if="userType != null && userType == 'Delta' && showQBRCategoryMaintain"
          :qbrCategoryList="qbrCategoryList"
          :group="group"
        ></QBRCategoryMaintain>
      </Card>
    </Feature>
    <Modal :z-index="modalSize" reset-drag-position v-model="selectRoleModel" :draggable="true" sticky :title="$t('CHOOSE_ROLE')" @on-ok="confirmMainRole">
      <Select v-model="roleCode" :placeholder="$t('CHOOSE_ROLE')" clearable>
        <Option v-for="(item, index) in roleList" :value="item.code" :key="index">
          {{ item.code }}
        </Option>
      </Select>
    </Modal>
    <Modal :z-index="modalSize" reset-drag-position v-model="uploadModel" :draggable="true" sticky :title="$t('UPLOAD') + ' ' + $t('CREATE_ACCOUNT')">
      <FormRow :fieldNameArr="['STEP1', '']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadDeltaTemplate">{{ $t('DELTA_SAMPLE')}}</Button>
        <Button icon="md-cloud-download" type="success" slot="b" @click="downloadSupplierTemplate">{{ $t('SUPPLIER_SAMPLE')}}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to system. Please input your data from second row.</I>
      <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
        <Upload
          slot="a"
          :before-upload="handleUpload"
          action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD')}}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD')}}</Button>
      </FormRow>
    </Modal>
  </article>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import SupplierPart from "@/views/account/SupplierPart"
import DeltaPart from "@/views/account/DeltaPart"
import ContactMaintain from "@/views/account/ContactMaintain"
import PICodeMaintain from "@/views/account/PICodeMaintain"
import PlantCodeMaintain from "@/views/account/PlantCodeMaintain"
import VNCodeMaintain from "@/views/account/VNCodeMaintain"
import QBRPlantCodeMaintain from "@/views/account/QBRPlantCodeMaintain"
import QBRVNCodeMaintain from "@/views/account/QBRVNCodeMaintain"
import QBRCategoryMaintain from "@/views/account/QBRCategoryMaintain"
import { AlertInfo } from "@/util/alert"
import { CheckNotChinese, CheckNotEmpty, DateToString } from "@/util/common"
import { Translate } from "@/util/common"
import moment from "moment"

export default {
  name: "Account",
  components: {
    SupplierPart,
    DeltaPart,
    ContactMaintain,
    PICodeMaintain,
    PlantCodeMaintain,
    VNCodeMaintain,
    QBRPlantCodeMaintain,
    QBRVNCodeMaintain,
    QBRCategoryMaintain,
  },
  created() {
    this.$authHttp
      .post(
        "role/search/attribute",
        JSON.stringify({
          attributeDtos: [
            {
              key: "GROUP_PERSON",
              value: "Group",
            },
            {
              key: "MAIN_ROLE",
              value: "Y",
            },
          ],
          paged: false,
        })
      )
      .then((response) => {
        this.roleList = response.data._embedded.roleResourceList
      })
      .catch(() => {})

    getRegion(this)
    checkSystemFunctions(this.systemFunctions, this)
  },
  data() {
    return {
      selectRoleModel: false,
      uploadModel: false,
      roleList: [],
      componentKey: 0,
      roleCode: "Supplier",
      group: {},
      groupCode: "",
      userType: null,
      specialFlag: false,
      isContactShow: false,
      isShowMainData: false,
      regionList: [],
      checkSpecialFlagRole: [],
      specialFlagRoleList: [],
      piCodeList: [],
      plantList: [],
      vnCodeList: [],
      qbrPlantCodeList: [],
      qbrVnCodeList: [],
      qbrCategoryList: [],
      isUpdate: false,
      isExceptionApplication: false,
      noGroupAccoutShow: false,
      file: null,
      checkErpType: '',
      system: "E-Procurement(EC) System"
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getGroupCode", "getLanguage", "getModalSize"]),
    ...mapActions(["toggleLoading"]),
    addGroupAccount() {
      const vueInstance = this;
      if (!vueInstance.checkGroupAccount(vueInstance.groupCode, "in_groupAcc")) {
        return;
      }
      vueInstance.toggleLoading(true);
      vueInstance.$vendorHttp
        .get("group-account?code=" + vueInstance.groupCode)
        .then(response => {
          vueInstance.toggleLoading(false);
          let text = "Already Exists";
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            text,
          });
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 444) {
            vueInstance.toggleLoading(false);
            vueInstance.selectRoleModel = true;
          }
        })
    },
    searchGroupAccount() {
      const vueInstance = this;
      if (!vueInstance.checkGroupAccount(vueInstance.groupCode, "in_groupAcc")) {
        return;
      }
      reset(vueInstance, vueInstance.groupCode);
      vueInstance.isContactShow = false;
      vueInstance.isShowMainData = false;
      vueInstance.toggleLoading(true);
      vueInstance.$vendorHttp
        .get("group-account?code=" + vueInstance.groupCode)
        .then(response => {
          vueInstance.isUpdate = true;
          vueInstance.group = response.data;
          vueInstance.group.role = vueInstance.group.mainRoles[0];
          vueInstance.group.role.attributes.forEach(attribute => {
            if (attribute.key == "DELTA_EXTERNAL") {
              vueInstance.userType = attribute.value
            }
            if (attribute.key == "CHECK_ERP") {
              vueInstance.checkErpType = attribute.value
            }
          });
          if (vueInstance.group.specialRoles) {
            vueInstance.group.specialRoles.forEach(specialRole => {
              if (specialRole.code == "FLAG_EXCEPTION_APPLICATION") {
                vueInstance.isExceptionApplication = true;
              }
              vueInstance.checkSpecialFlagRole.push(specialRole.code);
            });
          }
          vueInstance.isContactShow = true;
          vueInstance.isShowMainData = true;
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error);
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            });
          }
        });
    },
    async confirmMainRole() {
      let vueInstance = this
      if (vueInstance.roleCode) {
        let roleTemp = vueInstance.roleList.find(function (item, index, array) {
          return vueInstance.roleCode == item.code
        })

        if (await checkErp(roleTemp, vueInstance)) {
          vueInstance.group.role = roleTemp
          vueInstance.group.role.attributes.forEach((attribute) => {
            if (attribute.key == "DELTA_EXTERNAL") {
              vueInstance.userType = attribute.value
            }
            if (attribute.key == "CHECK_ERP") {
              vueInstance.checkErpType = attribute.value
            }
          })
          vueInstance.group.createDate = moment().format("yyyy-MM-DD")
          vueInstance.group.effectiveDate = moment().format("yyyy-MM-DD")
          vueInstance.$nextTick(() => {
            window.scrollTo({ top: vueInstance.$refs[vueInstance.userType].$el.offsetTop - 110, behavior: "smooth" })
          })
        }
      } else {
        this.$Message.error("請選擇角色")
        this.selectRoleModel = false
      }
    },
    checkGroupAccount(code, ref) {
      let vueInstance = this
      if (!CheckNotEmpty(code)) {
        AlertInfo(vueInstance, "請輸入群組帳號")
          .then(() => {
            setTimeout(() => vueInstance.$refs[ref].focus(), 200)
          });
        return false;
      }
      if (!CheckNotChinese(code.replace("_", "").replace("-", ""))) {
        AlertInfo(vueInstance, "群組帳號只可輸入數字和英文")
          .then(() => {
            setTimeout(() => vueInstance.$refs[ref].focus(), 200)
          });
        return false;
      }
      return true;
    },
    changeEffectiveDate(value) {
      this.group.effectiveDate = value
    },
    contactConfirm() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$vendorHttp
        .put("group-account/" + vueInstance.group.uuid + "/confirm-contact")
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.isShowMainData = true
        })
        .catch((error) => {
          vueInstance.isShowMainData = true
          let text = vueInstance.$buildErrorMessage(error)
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_INFO"),
            text,
          })
        })
    },
    uploadGroupAccount() {
      this.uploadModel = true
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile () {
      let fd = new FormData()
      fd.append('file', this.file)
      this.toggleLoading(true)
      this.$vendorHttp
        .post("/group-account/upload", fd)
        .then((response) => {
          console.log(response)
          this.toggleLoading(false)
          this.file = null
          this.uploadModel = false
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data._embedded.stringList[0],
          })
        })
        .catch((error) => {
          this.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    downloadDeltaTemplate() {
      this.$downloadMasterAttachment(this, 'AccountUpload(Delta)')
    },
    downloadSupplierTemplate() {
      this.$downloadMasterAttachment(this, 'AccountUpload(Supplier)')
    },
    async createGroupAccount(data) {
      const vueInstance = this;
      if (!vueInstance.validation(data)) {
        return;
      }
      vueInstance.toggleLoading(true);
      await vueInstance.$vendorHttp
        .post("group-account", JSON.stringify(data))
        .then(response => {
          vueInstance.group.uuid = response.data.uuid;
          vueInstance.group.companyName = response.data.companyName;
          vueInstance.group.companyGroup = response.data.companyGroup;
          vueInstance.group.companyAddress = response.data.companyAddress;
          vueInstance.group.country = response.data.country;
        })
        .catch(Error => {
          console.log(Error);
        });
      let promiseList = [];
      promiseList.push(this.$vendorHttp.put("/group-account/" + vueInstance.group.uuid + "/role/" + vueInstance.group.role.code));
      vueInstance.isExceptionApplication = false;
      vueInstance.specialFlagRoleList.forEach(role => {
        if (role.code == "FLAG_EXCEPTION_APPLICATION" && role.checked == "Y") {
          vueInstance.isExceptionApplication = true;
        }
        if (role.checked == "Y") {
          promiseList.push(vueInstance.$vendorHttp.put("/group-account/" + vueInstance.group.uuid + "/role/" + role.code));
        }
      });
      Promise.all(promiseList)
        .then(responses => {
          vueInstance.toggleLoading(false);
          vueInstance.isContactShow = true;
          vueInstance.$nextTick(() => {
            window.scrollTo({
              top: vueInstance.$refs.ContactMaintain.$el.offsetTop - 110,
              behavior: "smooth"
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    async updateGroupAccount(data, roleCode) {
      const vueInstance = this;
      if (!vueInstance.validation(data)) {
        return;
      }
      vueInstance.toggleLoading(true);
      await vueInstance.$vendorHttp
        .put("group-account/" + vueInstance.group.uuid, JSON.stringify(data))
        .then(response => {
          vueInstance.group.companyName = response.data.companyName;
          vueInstance.group.companyGroup = response.data.companyGroup;
          vueInstance.group.companyAddress = response.data.companyAddress;
          vueInstance.group.country = response.data.country;
        })
        .catch(error => {
          console.log(error);
        });
      let promiseList = [];
      if (vueInstance.userType == "Delta" && vueInstance.group.role.code !== roleCode) {
        promiseList.push(vueInstance.$vendorHttp.delete("/group-account/" + vueInstance.group.uuid + "/role/" + vueInstance.group.role.code));
        promiseList.push(vueInstance.$vendorHttp.put("/group-account/" + vueInstance.group.uuid + "/role/" + roleCode));
      }
      let changeCheckSpecialFlagRole = [];
      vueInstance.specialFlagRoleList.forEach(role => {
        if (role.checked == "Y") {
          changeCheckSpecialFlagRole.push(role.code)
          if (!vueInstance.checkSpecialFlagRole.includes(role.code)) {
            promiseList.push(vueInstance.$vendorHttp.put("/group-account/" + vueInstance.group.uuid + "/role/" + role.code));
          }
        } else if (role.checked == "N") {
          if (vueInstance.checkSpecialFlagRole.includes(role.code)) {
            promiseList.push(vueInstance.$vendorHttp.delete("/group-account/" + vueInstance.group.uuid + "/role/" + role.code));
          }
        }
      });
      vueInstance.isExceptionApplication = changeCheckSpecialFlagRole.some(roleCode => roleCode === "FLAG_EXCEPTION_APPLICATION");
      if (vueInstance.checkSpecialFlagRole.includes("FLAG_EXCEPTION_APPLICATION") === true 
          && vueInstance.isExceptionApplication === false) {
        promiseList.push(vueInstance.$vendorHttp.delete("group-account/all-employee/" + vueInstance.group.uuid + '/account'));
      }
      Promise.all(promiseList)
        .then(responses => {
          vueInstance.toggleLoading(false);
          vueInstance.isContactShow = true;
          if (vueInstance.userType == "Delta") {
            vueInstance.group.role.code = roleCode;
          }
          vueInstance.checkSpecialFlagRole = changeCheckSpecialFlagRole;
          vueInstance.$nextTick(() => {
            window.scrollTo({
              top: vueInstance.$refs.ContactMaintain.$el.offsetTop - 110,
              behavior: "smooth"
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    validation(data) {
      let errorMessage = "";
      let ref = "";
      if (!data.effectiveDate) {
        errorMessage += "請輸入生效日 <br>";
        ref = "effectiveDate";
      }
      if (this.userType == "Delta" && (data.name == undefined || data.name == "")) {
        errorMessage += "請輸入名稱 <br>";
        ref = "name";
      }
      if (data.regionCodeList.length == 0) {
        errorMessage += "請至少選擇一個地區 <br>";
      }
      if (errorMessage) {
        AlertInfo(this, errorMessage)
          .then(() => {});
        return false;
      }
      return true;
    }
  },
  watch: {
    groupCode() {
      reset(this, this.groupCode)
      this.isContactShow = false
      this.isShowMainData = false
    },
    systemFunctions(val, oldVal) {
      const vueInstance = this
      reset(vueInstance, "")
      checkSystemFunctions(val, vueInstance)
    },
    deep: true,
  },
  computed: {
    systemFunctions() {
      return this.getUserProfile().systemFunctions
    },
    canAdd() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_CREATE_GROUP_ACCOUNT_AREA")
      )
    },
    canSearch() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_SEARCH_GROUP_ACCOUNT_AREA")
      )
    },
    showPiCodeMaintain() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PI_CODE_RELATION_AREA_MODIFIABLE") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PI_CODE_RELATION_AREA_READONLY"))
      )
    },
    showVNCodeMaintain() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_VN_CODE_RELATION_AREA_MODIFIABLE") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_VN_CODE_RELATION_AREA_REDAONLY"))
      )
    },
    showPlantCodeMaintain() {
      let checkSupplier = true
      if (this.group.role.code == "SUPPLIER") {
        checkSupplier = this.getUserProfile().selectedGroup.mainRoles[0].code == "SUPPLIER"
      }
      return (
        this.getUserProfile().systemFunctions != undefined && checkSupplier &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PLANT_RELATION_AREA_MODIFIABLE") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PLANT_RELATION_AREA_READONLY"))
      )
    },
    showQBRPlantCodeMaintain() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_PLANT_RELATION_AREA_MODIFIABLE") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_PLANT_RELATION_AREA_READONLY"))
      )
    },
    showQBRVNCodeMaintain() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBRVN_CODE_RELATION_AREA_MODIFIABLE") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBRVN_CODE_RELATION_AREA_READONLY"))
      )
    },
    showQBRCategoryMaintain() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_CATEGORY_RELATION_AREA_MODIFIABLE") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_CATEGORY_RELATION_AREA_READONLY"))
      )
    },
    language() {
      return this.getLanguage()
    },
    modalSize() {
      return this.getModalSize()
    }
  },
}

function checkSystemFunctions(systemFunctions, vueInstance) {
  if (vueInstance.getGroupCode() == null) {
  } else {
    if (systemFunctions != undefined) {
      if (!systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_SEARCH_GROUP_ACCOUNT_AREA") && !systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_CREATE_GROUP_ACCOUNT_AREA")) {
        if (
          systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_CONTACT_PERSON_INFO_AREA_DELTA_MODIFIABLE") ||
          systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_CONTACT_PERSON_INFO_AREA_EXTERNAL_MODIFIABLE") ||
          systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_CONTACT_PERSON_INFO_AREA_READONLY")
        ) {
          vueInstance.toggleLoading(true)
          vueInstance.$vendorHttp
            .get("group-account?code=" + vueInstance.getGroupCode().code)
            .then((response) => {
              vueInstance.group = response.data

              vueInstance.group.role = vueInstance.group.mainRoles[0]
              vueInstance.group.role.attributes.forEach((attribute) => {
                if (attribute.key == "DELTA_EXTERNAL") {
                  vueInstance.userType = attribute.value
                }
                if (attribute.key == "CHECK_ERP") {
                  vueInstance.checkErpType = attribute.value
                }
              })
              if (vueInstance.group.specialRoles) {
                vueInstance.group.specialRoles.forEach((role) => {
                  if (role.code == "FLAG_EXCEPTION_APPLICATION") {
                    vueInstance.isExceptionApplication = true
                  }
                })
              }
              vueInstance.isUpdate = true
              vueInstance.isContactShow = true
              vueInstance.noGroupAccoutShow = true
              if (
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PI_CODE_RELATION_AREA_MODIFIABLE") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PI_CODE_RELATION_AREA_READONLY") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PLANT_RELATION_AREA_MODIFIABLE") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PLANT_RELATION_AREA_READONLY") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_PLANT_RELATION_AREA_MODIFIABLE") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_PLANT_RELATION_AREA_READONLY") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBRVN_CODE_RELATION_AREA_MODIFIABLE") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBRVN_CODE_RELATION_AREA_READONLY") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_CATEGORY_RELATION_AREA_MODIFIABLE") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_CATEGORY_RELATION_AREA_READONLY") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_VN_CODE_RELATION_AREA_MODIFIABLE") ||
                systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_VN_CODE_RELATION_AREA_REDAONLY")
              ) {
                vueInstance.isShowMainData = true
              }
            })
            .catch(() => {})
        }
      }
    }
  }
}

async function checkErp(roleTemp, vueInstance) {
  let result = false
  let attributeChectErp = roleTemp.attributes.find(function (item, index, array) {
    return item.key == "CHECK_ERP"
  })

  if (attributeChectErp.value == "Y") {
    vueInstance.toggleLoading(true)
    await vueInstance.$vendorHttp
      .get("group-account/check-erp?code=" + vueInstance.group.code)
      .then((response) => {
        vueInstance.toggleLoading(false)
        vueInstance.group = response.data
        vueInstance.group.name = response.data.code
        result = true
      })
      .catch((error) => {     
        if (error.response.status == 444) {
          let text = vueInstance.$buildErrorMessage(error)
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            text,
          })
        }}
      )
  } else if (attributeChectErp.value == "N") {
    result = true
  }
  return result
}

async function buildGroupData(vueInstance, isLock, remarks, regions) {
  vueInstance.group.remarks = remarks
  if (isLock == "Y") {
    vueInstance.group.isLock = true
  } else if (isLock == "N") {
    vueInstance.group.isLock = false
  }
  vueInstance.group.regions = regions
}

function getRegion(vueInstance) {
  vueInstance.$authHttp
    .get("region")
    .then((response) => {
      vueInstance.regionList = response.data._embedded.regionResourceList
    })
    .catch(() => {})
}

function reset(vueInstance, groupCode) {
  vueInstance.selectRoleModel = false
  vueInstance.componentKey = 0
  vueInstance.roleCode = "Supplier"
  vueInstance.group = {
    role: null,
    code: groupCode,
  }
  ;(vueInstance.userType = null),
    (vueInstance.specialFlag = false),
    (vueInstance.isContactShow = false),
    (vueInstance.isShowMainData = false),
    (vueInstance.checkSpecialFlagRole = []),
    (vueInstance.specialFlagRoleList = []),
    (vueInstance.piCodeList = []),
    (vueInstance.plantList = []),
    (vueInstance.vnCodeList = []),
    (vueInstance.qbrPlantCodeList = []),
    (vueInstance.qbrVnCodeList = []),
    (vueInstance.qbrCategoryList = []),
    (vueInstance.isUpdate = false)
  vueInstance.noGroupAccoutShow = false
}


</script>

<style scoped></style>
